<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div class="zv-breadcrumb-wrap">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/data-input/CountryBase' }">国别基础信息库</el-breadcrumb-item>
            <el-breadcrumb-item>国别指南修改</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="headContainer">
          <el-backtop target=".headContainer">
            <i class="el-icon-caret-top"></i>
          </el-backtop>
          <el-form ref="formData" :model="formData" label-width="160px">
            <el-form-item label="国家名称*">{{formData.area_name}}</el-form-item>
            
            <el-form-item label="启用/禁用">
              <el-switch
                v-model="formData.guide_status"
                @change="changeStatus(formData.guide_status)"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-form-item>
            
           

            <el-form-item label="国家风险描述">
              <quill-editor v-model="formData.guide_risk_descr"
                ref="myQuillEditor"
                class="editer"
                :options="editorOption" @ready="onEditorReady($event)">
              </quill-editor>
            </el-form-item>

            <el-form-item label="国家公共安全风险">
              <quill-editor v-model="formData.guide_public_risk"
                ref="myQuillEditor"
                class="editer"
                :options="editorOption" @ready="onEditorReady($event)">
              </quill-editor>
            </el-form-item>

            <el-form-item label="华人风险及规避">
              <quill-editor v-model="formData.guide_chinese_risk"
                ref="myQuillEditor"
                class="editer"
                :options="editorOption" @ready="onEditorReady($event)">
              </quill-editor>
            </el-form-item>

            <el-form-item label="重点地区公共安全风险">
              <quill-editor v-model="formData.guide_key_area_risk"
                ref="myQuillEditor"
                class="editer"
                :options="editorOption" @ready="onEditorReady($event)">
              </quill-editor>
            </el-form-item>

            <el-form-item label="出入境及海关规定">
              <quill-editor v-model="formData.guide_border_rule"
                ref="myQuillEditor"
                class="editer"
                :options="editorOption" @ready="onEditorReady($event)">
              </quill-editor>
            </el-form-item>

            <el-form-item label="实用信息">
              <quill-editor v-model="formData.guide_useful_information"
                ref="myQuillEditor"
                class="editer"
                :options="editorOption" @ready="onEditorReady($event)">
              </quill-editor>
            </el-form-item>

            <el-form-item label="紧急救助卡">
              <quill-editor v-model="formData.guide_emergency_information"
                ref="myQuillEditor"
                class="editer"
                :options="editorOption" @ready="onEditorReady($event)">
              </quill-editor>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="guideAdd">提交</el-button>
              <el-button @click="goToCountryBase">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor' //调用编辑器
import uploadFlie from "@/components/unloadFile/index";
import timeZoneSelect from "./time_zone";
import api from "../api";
import tokenService from "@/utils/services/token_service"

export default {
  components: { uploadFlie,quillEditor },
  data() {
    return {
      countryTitle: "新增条目", //标题
      editorOption: {
        placeholder: '请输入正文'
      },
      formData: {
        countryName: '',
        status: '',
        guide_risk_descr: ''
      }
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    }
  },
  created() {
    this.guideInfo()
  },
  methods: {
    guideInfo() {
      let data = {
        id: this.$route.query.countryId,
      };
      api
        .countryInfoShow(data)
        .then(res => {
          this.formData = res.info
          console.log(res)
        })
        .catch(err => {
          this.$message(err);
        });
    },

    guideAdd() {
      let data = this.formData
      this.$set(data,'id',this.$route.query.countryId)
      api
        .adminGuideEdit(data)
        .then(res => {
          console.log(res)
          this.$message({
            message: "提交成功！",
            type: "success"
          });
          setTimeout((item) => {
            this.$router.push({
              name: "countryBase"
            });
          },2000)
          
        })
        .catch(err => {
          this.$message(err);
        });
    },

    

    // 取消跳转原页面
    goToCountryBase() {
      this.$router.push({
        name: "countryBase"
      });
    }
  }
};
</script>

<style>
  .edit_container {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
  .ql-editor{
      height:200px;
    }
</style>